import { z } from 'zod'

export const SshKey = z.object({
  id: z.number(),
  name: z.string(),
  public_key: z.string(),
  fingerprint: z.string(),
  active: z.boolean(),
  created: z.string()
})

export const SshKeyCreateRequest = z.object({
  name: z.string(),
  public_key: z.string()
})

export const SshKeyUpdateRequest = z.object({
  name: z.string().optional(),
  active: z.boolean().optional()
})

export type SshKey = z.infer<typeof SshKey>
export type SshKeyCreateRequest = z.infer<typeof SshKeyCreateRequest>
export type SshKeyUpdateRequest = z.infer<typeof SshKeyUpdateRequest>
